var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "itinerary-selection spa-soft-page" },
    [_c("ItineraryHeader"), _vm._v(" "), _c("TimeslotList")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }